module.exports = __webpack_public_path__ + "img/4-2.d3e5d45f.png";